import templateUrl from "webforms/formio/formio-container.htm";
import listTemplateUrl from "webforms/formio/formio-list.htm";
import controller from "webforms/formio/formio-container.controller";

const isList = (type = "") => type === "list" || type === "mutli-view";

export default {
  bindings: {
    ngModel: "=?",
    formioId: "<?",
    hideHeader: "@",
    layout: "@",
    disableQueryString: "<",
    mode: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      (isList($attrs.layout) ? listTemplateUrl : templateUrl)
    );
  },
};
